import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TooltipOffset from './TooltipOffset';
import ClientProvider from './client';
export default createDemo(import.meta.url, TooltipOffset, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tooltips/demos/offset/TooltipOffset.tsx",
    "fileName": "TooltipOffset.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\n\nexport default function TooltipOffset() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Tooltip\n      describeChild\n      title=\"Add\"\n      slotProps={{\n        popper: {\n          modifiers: [\n            {\n              name: 'offset',\n              options: {\n                offset: [0, -14],\n              },\n            },\n          ],\n        },\n      }}\n    >\n      <Button>Offset</Button>\n    </Tooltip>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 25,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\n\nexport default function TooltipOffset() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Tooltip\n      describeChild\n      title=\"Add\"\n      slotProps={{\n        popper: {\n          modifiers: [\n            {\n              name: 'offset',\n              options: {\n                offset: [0, -14],\n              },\n            },\n          ],\n        },\n      }}\n    >\n      <Button>Offset</Button>\n    </Tooltip>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 25,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/material/Tooltip"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
